/**
 * MenuContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the menu container.
 */
interface Props {
  collapse: boolean;
}

/**
 * Styled container for the menu.
 */
const MenuContainer = styled.div<Props>`
  background: ${({ collapse }) =>
    collapse ? 'rgba(0, 0, 0, 0.5)' : 'transparent'};
  border: ${({ collapse }) =>
    collapse ? `1px solid ${Colors['menu']['border']}` : 'none'};
  padding-left: ${({ collapse }) => (collapse ? 20 : 42) * Screen.widthRatio}px;
  padding-right: ${20 * Screen.widthRatio}px;
  margin-right: ${({ collapse }) => (collapse ? 57 : 20) * Screen.widthRatio}px;
  width: ${({ collapse }) => (collapse ? 24 : 268) * Screen.widthRatio}px;
  z-index: 50; // Above the slider list, at the same level as the top bar
`;

export default withOpacity(MenuContainer);
